/**
 * SplashScreen
 * ------------
 * Held for the one moment between a cold start and knowing whether the refresh
 * cookie is still good.
 *
 * It exists so a reload never flashes the login screen at someone who is in
 * fact signed in. Deliberately plain — Midnight Navy ground, the mark, a
 * candlelight spinner — because it is on screen for a few hundred milliseconds
 * and anything busier would read as a stutter.
 */
import { Box, CircularProgress } from '@mui/material';

export default function SplashScreen() {
  return (
    <Box
      sx={{
        minHeight: '100dvh',
        display: 'grid',
        placeItems: 'center',
        background: 'linear-gradient(160deg,#16294A 0%,#11223E 55%,#0A1425 100%)',
      }}
      role="status"
      aria-live="polite"
    >
      <Box sx={{ display: 'grid', placeItems: 'center', gap: 3 }}>
        <Box
          component="svg"
          viewBox="0 0 132 232"
          sx={{ width: 44, height: 'auto', filter: 'drop-shadow(0 0 22px rgba(192,167,134,.45))' }}
          aria-hidden="true"
        >
          <path fill="#C0A786" d="M43 1C40.5 0.5 31 38 63 61C73 63.5 73 18 43 1Z" />
          <path
            fill="#FFFFFF"
            d="M0 71H58L66 75L74 71H132V75C105 119 105 188 132 232H0V232C27 188 27 119 0 75Z"
          />
        </Box>
        <CircularProgress size={22} thickness={4} sx={{ color: '#C0A786' }} />
      </Box>
    </Box>
  );
}
